export default __webpack_public_path__ + "static/media/i6.34915249.svg";